import React from 'react';
import ReactDOM from 'react-dom';
import { Route, Router, browserHistory, Redirect } from 'react-router';
import { Provider } from 'react-redux';
import Downloads from '../components/Downloads';
import Saved from '../components/Saved';
import Reviews from '../components/Reviews';
import createStoreAndRunSagas from '../../modules/createStoreAndRunSagas';
import '../index.scss';

function initializeMainContent() {
  if (window.TES && !window.TES.userMetadata.id) return window.TES.events.trigger('auth-open', 'sign-in');
  const store = createStoreAndRunSagas();
  const history = document.history || browserHistory;
  if (!document.history) document.history = history;

  ReactDOM.render(
    <Provider store={store}>
      <Router history={history}>
        <Route path="/">
          <Redirect from="my-resources/favourites" to="my-resources/saved"></Redirect>
          <Redirect from="my-resources/downloads" to="my-resources/"></Redirect>
          <Redirect from="my-resources/buyer-dashboard" to="my-resources/"></Redirect>
          <Route component={Saved} path="my-resources/saved"></Route>
          <Route component={Reviews} path="my-resources/reviews"></Route>
          <Route component={Downloads} path="my-resources"></Route>
          <Redirect from="my-resources/*" to="my-resources/"></Redirect>
        </Route>
      </Router>
    </Provider>,
    window.document.getElementById('app-content'),
  );
}

document.addEventListener('DOMContentLoaded', initializeMainContent);
